import { setUsersListData } from '@/store';
import { USERS_LIST_TAG } from '../constants';
import { api } from '../core';

export interface UserData {
  userEmail: string;
  userId: string;
  userName: string;
}
export interface UsersListResponse {
  users: UserData[];
}

type GetUsersListProps = {
  abortController?: AbortController;
};

const getUsersListApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUsersList: builder.query<UsersListResponse, GetUsersListProps>({
      query: ({ abortController = new AbortController() }: GetUsersListProps) => ({
        url: `users/list`,
        method: 'GET',
        signal: abortController.signal
      }),
      providesTags: () => [{ type: USERS_LIST_TAG }],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (data?.users) {
            dispatch(setUsersListData(data.users));
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getUsersList in onQueryStarted:', error);
          }
        }
      }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetUsersListQuery } = getUsersListApi;
